import ApiService from "@/core/services/ApiService";
import { Actions, APIEndpoints } from "@/store/enums/StoreEnums";
import { Module, Action, VuexModule, config } from "vuex-module-decorators";

config.rawError = true;

@Module
export default class AvailableJobModule extends VuexModule {
  @Action
  [Actions.GET_JOBS_WITH_MY_OFFERS]() {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.get(
        `/attorney/${APIEndpoints.JOBS}/${APIEndpoints.JOBS_WITH_MY_OFFERS}`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.BID_A_JOB](payload: any) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.post(
        `/attorney/${APIEndpoints.JOBS}/${payload.jobId}/${APIEndpoints.BID}`,
        payload.data
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action
  [Actions.ADD_NEW_DRAFT_OFFER](payload: any) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.post(
        `/attorney/${APIEndpoints.JOBS}/${payload.jobId}/${APIEndpoints.ADD_DRAFT_OFFER}`,
        payload.data
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.UPDATE_DRAFT_OFFER](payload: any) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.put(
        `/attorney/${APIEndpoints.JOBS}/${payload.jobId}/offers/${payload.offerId}`,
        payload.data
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.SUBMIT_OFFER](payload: any) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.get(
        `/attorney/${APIEndpoints.JOBS}/${payload.jobId}/offers/${payload.offerId}/${APIEndpoints.SUBMIT}`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.CANCEL_OFFER](payload: any) {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.get(
        `/attorney/${APIEndpoints.JOBS}/${payload.jobId}/offers/${payload.offerId}/${APIEndpoints.CANCEL}`
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
